export default "__VITE_ASSET__BDP5KZlP__"